import React from 'react';

/**
 * A non-interactive status line: bottom-centre, one sentence, gone in a moment.
 *
 * Kept in the DOM and toggled with `.open` rather than mounted and unmounted, so
 * it can fade out as well as in — `.toast`'s visibility transition is delayed by
 * its own duration for exactly that.
 */
const Toast = ({ message, visible }) => (
    <div className={`toast ${visible ? 'open' : ''}`} role="status" aria-live="polite">
        {message}
    </div>
);

export default Toast;
